import React, { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import ReactPlayer from 'react-player';

import styles from "../styles/header.module.css";


const Header = () => {

    return (
        <div className={styles.header_container}>
            <header className={styles.header}>
                <Link to="/" className={styles.logo_container}>
                    <div className={styles.logo}>
                        <img
                            src="../../assets/images/th_logo.png"
                        />
                    </div>
                </Link>
            </header>
        </div>
    );
};

export default Header;
